import { Country } from '../model/default-config.model';

const getCountryZoneUtil = (destination: string | null, countries?: Country[]): string | undefined => {
  destination = destination?.replace('H', '') || null;
  const zone = countries?.find(({ countryId }) => String(countryId) === String(destination))?.zone;

  return zone?.toLowerCase();
};

export default getCountryZoneUtil;
